import '../../global'
import { doc, getDoc } from 'firebase/firestore'
import { db } from '../../firebase/config'
import { transformFirestoreResponse } from '../utils/firestoreTransform'
import { firestoreGet } from '../../utils/firestoreApi'

export const mergeCheckoutConfig = (defaultConfig, userConfig) => {
	const merged: any = {
		kiosk: {
			requiredFields: { ...defaultConfig.kiosk.requiredFields },
		},
		guest: {
			requiredFields: { ...defaultConfig.guest.requiredFields },
		},
		webMob: {
			requiredFields: { ...defaultConfig.webMob.requiredFields },
		},
	}

	// Merge user config into the new object
	Object.entries(userConfig).forEach(([key, value]: any) => {
		if (value && typeof value === 'object' && 'requiredFields' in value) {
			merged[key] = {
				requiredFields: {
					...merged[key].requiredFields,
					...value.requiredFields,
				},
			}
		}
	})

	return merged
}

export const getOrgData = () => {
	return new Promise((resolve, reject) => {
		const orgRef = doc(db, 'Organizations-v2', global.org)
		getDoc(orgRef)
			.then(docSnapshot => {
				if (docSnapshot.exists()) {
					const data = docSnapshot.data()
					resolve(data)
				} else {
					reject(new Error('Org document does not exist.'))
				}
			})
			.catch(error => {
				reject(error)
			})
	})
}

export const getOrgDataForBot = () => {
	const endpoint = `Organizations-v2/${global.org}`

	return firestoreGet(endpoint).then(data => {
		if (data) {
			const transformedData = transformFirestoreResponse(data)
			return transformedData
		} else {
			throw new Error('Org document does not exist.')
		}
	})
}
